module.exports = __webpack_public_path__ + "77d471c0f5286973cef685df9aa216a9.png";